/** @jsxImportSource @emotion/react */
"use client";

import Image from "next/image";
import Card from "@mui/material/Card";
import Link from "@mui/material/Link";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { format } from "date-fns";
import { tr } from "date-fns/locale";
import { useRouter } from "next/navigation";

import {
  cardStyle,
  contentStyle,
  linkStyle,
  mediaWrapperStyle,
} from "./styles";

export interface BlogCardProps {
  slug: string;
  title: string;
  date: string;
  content: string;
  image: string;
}

export const BlogCard = ({
  slug,
  title,
  date,
  content,
  image,
}: BlogCardProps) => {
  const router = useRouter();

  const handleCardClick = () => {
    router.push(`/blog/${slug}`);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getExcerpt = (blocks: any[] | string, maxLength = 300): string => {
    if (!Array.isArray(blocks)) return "";

    const plainText = blocks
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .flatMap((block) => block.children?.map((child: any) => child.text) ?? [])
      .join(" ")
      .trim();

    return plainText.length > maxLength
      ? plainText.slice(0, maxLength) + "..."
      : plainText;
  };

  return (
    <Card onClick={handleCardClick} css={cardStyle}>
      <CardMedia component="div" css={mediaWrapperStyle}>
        <Image
          src={image}
          alt={title}
          fill
          sizes="(max-width:444px) 100vw, 444px"
          priority
        />
      </CardMedia>

      <CardContent>
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <CalendarTodayIcon fontSize="small" />
          <Typography variant="body2" component="h2">
            {format(new Date(date), "d MMMM yyyy", { locale: tr })}
          </Typography>
        </Box>
        <Typography variant="h6" component="h3" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" css={contentStyle}>
          {getExcerpt(content, 232)}
        </Typography>

        <Link
          href={`/blog/${slug}`}
          onClick={(e) => e.stopPropagation()}
          underline="hover"
          css={linkStyle}
        >
          DEVAMINI OKU
        </Link>
      </CardContent>
    </Card>
  );
};
